import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { plPL } from '@mui/x-data-grid/locales';
import { CompetenceCounts, CompetenceStat, Competency, CompetenceStatsResponse } from './OrganizationComponentStats.types';
import { useTranslation } from "react-i18next";
import './OrganizationComponentStats.scss'

const OrganizationComponentStats = ({competenceStatsResponse}: {competenceStatsResponse: CompetenceStatsResponse}) => {
  const {t} = useTranslation()
  const columns: GridColDef<Competency>[] = [
    {
      field: 'areaName', headerName: t("reports.tableHeaderArea"), headerClassName: 'headerClass', width: 250
    },
    {
      field: 'competenceLevel', headerName: t("reports.tableHeaderCompetenceLevel"), headerClassName: 'headerClass', width: 200
    },
    {
      field: 'knownCompetences', headerName: t("reports.tableHeaderKnownCompetences"), headerClassName: 'headerClass', width: 200
    },
    {
      field: 'allCompetences', headerName: t("reports.tableHeaderAllCompetences"), headerClassName: 'headerClass', width: 200
    },
  ]

  const compotenceLevelesSet = new Set<string>();
  const rows: Competency[] = []
  if(competenceStatsResponse) {
    competenceStatsResponse.competence_stats.map((competenceStat: CompetenceStat) => {
      const compotencyLevels = Object.keys(competenceStat.competence_counts)
      compotencyLevels.map((competencyLevel) => {
        compotenceLevelesSet.add(competencyLevel)
        const competency: Competency = { 
          id: competenceStat.area_id + competencyLevel,
          areaName: '', 
          competenceLevel: '', 
          knownCompetences: 0, 
          allCompetences: 0 
        };
        competency.areaName = competenceStat.area_name
        competency.competenceLevel = competencyLevel.replace(/_/g, " ")
        const competenceLevelData = competenceStat.competence_counts?.[competencyLevel as keyof CompetenceCounts];

        if (
          competenceLevelData !== undefined &&
          competenceLevelData.known_competences !== undefined &&
          competenceLevelData.all_competences !== undefined
        ) {
          competency.knownCompetences = competenceLevelData.known_competences
          competency.allCompetences = competenceLevelData.all_competences
        }
        rows.push(competency)
      })  
    })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '50px', maxWidth: '1200px' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: compotenceLevelesSet.size,
            },
          },
        }}
        pageSizeOptions={[compotenceLevelesSet.size, {value: Math.ceil(rows.length/2), label:  Math.ceil(rows.length/2) + ''}, { value: -1, label: 'All' }]}
        getRowClassName={(params) => {
            if(params.indexRelativeToCurrentPage % 2 !== 0) {
              return 'darkerRow'
            } else {
              return ''
            }
          }
        }
        disableRowSelectionOnClick
        localeText={{
          MuiTablePagination: {
            labelRowsPerPage: t("reports.rowsPerPage"),
            labelDisplayedRows: ({ from, to, count }) =>
              `${from}–${to} ${t("reports.rowsPaginationFrom")} ${count}`,
          }
        }}
      />
    </div>
  )
}

export default OrganizationComponentStats